/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RoomStatus = {
    properties: {
        id: {
    type: 'number',
},
        roomId: {
    type: 'number',
},
        roomName: {
    type: 'string',
},
        bedId: {
    type: 'number',
},
        bedName: {
    type: 'string',
},
        status: {
    type: 'string',
    isRequired: true,
},
        comment: {
    type: 'string',
},
        createdBy: {
    type: 'IdName',
    isRequired: true,
},
        updatedBy: {
    type: 'IdName',
},
        averageRating: {
    type: 'number',
},
        createdAt: {
    type: 'string',
},
        updatedAt: {
    type: 'string',
},
    },
};